'use client';

import { useTriviaRumbleStats } from '@wwe-portal/web/providers/queries/trivia-rumble';

import { useResponsive } from '../../../../../packages/ui/hooks/use-responsive';
import { TriviaGameUserStatsItem } from './stat-item';
import { InfoTooltip } from '../../../../../packages/ui/components/tooltip/info-tooltip';
import { useTranslations } from 'next-intl';
import {
  Carousel,
  CarouselContent,
  CarouselIndicator,
  CarouselItem,
} from '../../../../../packages/ui/components/carousel/carousel';

export const TriviaStats = () => {
  const t = useTranslations();
  const { data: triviaRumbleStats } = useTriviaRumbleStats();
  const { isMobile } = useResponsive();
  const triviaItems = [
    <TriviaGameUserStatsItem
      icon="crown"
      title={triviaRumbleStats?.data.data.winGamesCount ?? '-'}
      description="your_wins"
      key="your_wins"
    />,
    <TriviaGameUserStatsItem
      icon="percent-fill"
      title={triviaRumbleStats?.data.data.winRate ?? '-'}
      description="win_rate"
      key="win_rate"
    />,
    <TriviaGameUserStatsItem
      icon="chart-fill"
      title={triviaRumbleStats?.data.data.rank ?? '-'}
      description="global_rank"
      key="global_rank"
      tooltip={
        <InfoTooltip
          titleClassName="trivia-tooltip ml-2 mr-0"
          content={t('global_rank_info')}
          contentProps={{
            side: 'top',
          }}
        />
      }
    />,
    <TriviaGameUserStatsItem
      icon="won-fill"
      title={triviaRumbleStats?.data.data.points ?? '-'}
      description="points"
      key="points"
    />,
  ];
  if (isMobile)
    return (
      <Carousel opts={{ skipSnaps: true }}>
        <CarouselContent className="-ml-4">
          {triviaItems.map((item) => (
            <CarouselItem
              key={item.key}
              className="basis-[40%] cursor-pointer select-none"
            >
              {item}
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselIndicator className="mt-6 gap-1" />
      </Carousel>
    );
  return <div className="grid grid-cols-4 gap-5">{triviaItems}</div>;
};
